/* eslint-disable no-bitwise */
/* eslint-disable no-mixed-operators */
/* eslint-disable no-param-reassign */

// eslint-disable-next-line import/prefer-default-export
export const SampleAppUtilities = (() => {
  function displayStatus() {
    // document.getElementById('status').innerHTML = message;
  }

  function showMainUI() {
    // document.querySelector('.wrapping-box-container').style.opacity = 1;
    SampleAppUtilities.enableAllButtons();
  }

  function disableAllButtons() {
    document.querySelectorAll('button').forEach((button) => {
      button.disabled = true;
    });
  }

  function fadeOutMainUIAndPrepareForSession() {
    disableAllButtons();
    // document.querySelector('.wrapping-box-container').style.opacity = 0;
  }

  function enableAllButtons() {
    document.querySelectorAll('button').forEach((button) => {
      button.disabled = false;
    });
  }

  function handleErrorGettingServerSessionToken() {
    // fadeInMainUI();
    enableAllButtons();
    displayStatus('Session could not be started due to an unexpected issue during the network request.');
  }

  function generateUUId() {
    // @ts-ignore
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) => (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16));
  }

  function isLikelyMobileDevice() {
    let isMobileDeviceUA = !!(/Android|iPhone|iPad|iPod|IEMobile|Mobile|mobile/i.test(navigator.userAgent || ''));
    // ChromeOS/Chromebook detection.
    if (isMobileDeviceUA && ((navigator.userAgent.indexOf('CrOS') !== -1) || (navigator.userAgent.indexOf('Chromebook') !== -1))) {
      isMobileDeviceUA = false;
    }
    // Mobile device determination based on portrait / landscape and user agent.
    // eslint-disable-next-line no-restricted-globals
    if (screen.width < screen.height || isMobileDeviceUA) {
      // Assume mobile device when in portrait mode or when determined by the user agent.
      return true;
    }
    return false;
  }

  function formatUIForDevice() {
    if (isLikelyMobileDevice()) {
      // Adjust button sizing
      document.querySelectorAll('.controls > button').forEach((element) => {
        if (element.className === 'big-button') {
          (element).style.height = '40px';
          (element).style.fontSize = '18px';
        } else if (element.className === 'medium-button') {
          (element).style.height = '30px';
          (element).style.fontSize = '14px';
        }

        (element).style.width = '220px';
      });
      // Hide border around control panel
      (document.getElementById('controls')).style.borderColor = 'transparent';
      // Center control interface on screen
    }
  }

  return {
    displayStatus,
    showMainUI,
    fadeOutMainUIAndPrepareForSession,
    disableAllButtons,
    enableAllButtons,
    generateUUId,
    formatUIForDevice,
    handleErrorGettingServerSessionToken,
  };
})();
